import { render, staticRenderFns } from "./coachApplyAuthList.vue?vue&type=template&id=972044a8&scoped=true&"
import script from "./coachApplyAuthList.vue?vue&type=script&lang=js&"
export * from "./coachApplyAuthList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972044a8",
  null
  
)

export default component.exports